// Company: Ajinsoft
// Author: Uilan Coqueiro
// Date: 2023-03-30
// Version: 3

import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AjinDialogBoxConfig, AjinDialogBoxResult } from './dialog-box.models';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
	selector: 'ajin-dialog-box',
	templateUrl: './dialog-box.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		TranslocoModule
	]
})
export class AjinDialogBoxComponent implements OnInit {

	okButton = false;
	confirmButton = false;
	retryButton = false;
	cancelButton = false;
	yesButton = false;
	noButton = false;
	abortButton = false;
	ignoreButton = false;
	saveButton = false;
	noSaveButton = false;

	result = {
		text: ''
	};


	constructor(
		public dialogRef: MatDialogRef<AjinDialogBoxComponent>,
		@Inject(MAT_DIALOG_DATA) public data: AjinDialogBoxConfig) {
	}

	ngOnInit(): void {

		if (!this.data) return;

		if (this.data.actions === 'ok') {
			this.okButton = true;
			setTimeout(() => {
				document.getElementById('ok')?.focus();
			}, 300);
		}

		if (this.data.actions === 'okCancel') {
			this.okButton = true;
			this.cancelButton = true;

			setTimeout(() => {
				document.getElementById('ok')?.focus();
			}, 300);
		}

		if (this.data.actions === 'confirmCancel') {
			this.confirmButton = true;
			this.cancelButton = true;

			setTimeout(() => {
				document.getElementById('confirm')?.focus();
			}, 300);
		}

		if (this.data.actions === 'retryCancel') {
			this.retryButton = true;
			this.cancelButton = true;

			setTimeout(() => {
				document.getElementById('retry')?.focus();
			}, 300);
		}

		if (this.data.actions === 'yesNoCancel') {
			this.yesButton = true;
			this.noButton = true;
			this.cancelButton = true;

			setTimeout(() => {
				document.getElementById('yes')?.focus();
			}, 300);
		}

		if (this.data.actions === 'saveNoSaveCancel') {
			this.saveButton = true;
			this.noSaveButton = true;
			this.cancelButton = true;

			setTimeout(() => {
				document.getElementById('save')?.focus();
			}, 300);
		}

		if (this.data.actions === 'yesNo') {
			this.yesButton = true;
			this.noButton = true;

			setTimeout(() => {
				document.getElementById('yes')?.focus();
			}, 300);
		}

		if (this.data.actions === 'abortRetryIgnore') {
			this.abortButton = true;
			this.retryButton = true;
			this.ignoreButton = true;

			setTimeout(() => {
				document.getElementById('abort')?.focus();
			}, 300);
		}
	}

	confirm(action: AjinDialogBoxResult): void {
		if (this.result?.text) {
			action.text = this.result?.text;
		}

		this.dialogRef.close(action);
	}
}


